import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            meta: {
                redirect: {name: 'Forums'},
            },
            component: () => import('@/layouts/Layout'),
            children: [
                // Components
                /* {
                    name: 'Profile',
                    path: 'pages/profile',
                    component: () => import('@/views/pages/Profile'),
                }, */
                {
                    name: 'ProjectDocuments',
                    path: 'project-documents/:project',
                    component: () => import('@/views/pages/ProjectDocumentsPage'),
                    props: {title: 'Список документов'},
                },
                {
                    name: 'DocumentEditor',
                    path: 'document-editor/:project/:document',
                    component: () => import('@/views/pages/DocumentEditorPage'),
                    props: {title: 'Редактирование отчета'},
                },
                {
                    path: 'pages/forums',
                    component: () => import('@/components/BreadCrumbs/BreadCrumbItem'),
                    redirect: {name: 'Forums'},
                    props: {title: 'Мероприятия'},
                    meta: {
                        permissionsByModule: 'forums',
                    },
                    children: [
                        {
                            name: 'Forums',
                            path: '/',
                            component: () => import('@/views/pages/Forums'),
                        },
                        {
                            path: ':ID_FORUM',
                            component: () => import('@/components/BreadCrumbs/BreadCrumbForum'),
                            redirect: {name: 'ForumEvents'},
                            children: [
                                {
                                    name: 'ForumEvents',
                                    path: '/',
                                    component: () => import('@/views/pages/ForumEvents'),
                                },
                                {
                                    path: ':ID_EVENT',
                                    component: () => import('@/components/BreadCrumbs/BreadCrumbEvent'),
                                    redirect: {name: 'ForumEvent'},
                                    children: [
                                        {
                                            name: 'ForumEvent',
                                            path: '/',
                                            component: () => import('@/views/pages/ForumEventSessions'),
                                            meta: {
                                                redirectIndex: true,
                                            },
                                            children: [
                                                {
                                                    path: 'sessions',
                                                    component: () => import('@/components/BreadCrumbs/BreadCrumbItem'),
                                                    redirect: {name: 'ForumEventSessions'},
                                                    props: {title: 'Сессии'},
                                                    children: [
                                                        {
                                                            name: 'ForumEventSessions',
                                                            path: '/',
                                                            component: () => import('@/components/Projects/ProjectsSessions'),
                                                        },
                                                        {
                                                            path: ':ID_SESSION',
                                                            component: () => import('@/components/BreadCrumbs/BreadCrumbSession'),
                                                            redirect: {name: 'ForumEventSession'},
                                                            children: [
                                                                {
                                                                    name: 'ForumEventSession',
                                                                    path: '/',
                                                                    component: () => import('@/views/pages/ForumEventSession'),
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                {
                                                    path: 'wordclouds',
                                                    component: () => import('@/components/BreadCrumbs/BreadCrumbItem'),
                                                    redirect: {name: 'ForumEventWordclouds'},
                                                    props: {title: 'Облака смыслов'},
                                                    children: [
                                                        {
                                                            name: 'ForumEventWordclouds',
                                                            path: '/',
                                                            component: () => import('@/components/Projects/ProjectsWordclouds'),
                                                        },
                                                        {
                                                            path: ':ID_WORDCLOUDS',
                                                            component: () => import('@/components/BreadCrumbs/BreadCrumbWordCloud'),
                                                            redirect: {name: 'ForumEventWordCloud'},
                                                            children: [
                                                                {
                                                                    name: 'ForumEventWordCloud',
                                                                    path: '/',
                                                                    component: () => import('@/views/pages/ForumEventWordCloud.vue'),
                                                                },
                                                            ]
                                                        },
                                                    ],
                                                },
                                                {
                                                    path: 'quotes',
                                                    component: () => import('@/components/BreadCrumbs/BreadCrumbItem'),
                                                    redirect: {name: 'ForumEventQuotes'},
                                                    props: {title: 'Цитаты'},
                                                    children: [
                                                        {
                                                            name: 'ForumEventQuotes',
                                                            path: '/',
                                                            component: () => import('@/components/Projects/ProjectsQuotes'),
                                                        },
                                                    ],
                                                },
                                                {
                                                    path: 'digests',
                                                    component: () => import('@/components/BreadCrumbs/BreadCrumbItem'),
                                                    redirect: {name: 'ForumEventDigests'},
                                                    props: {title: 'Дайджесты', cache: false},
                                                    children: [
                                                        {
                                                            name: 'ForumEventDigests',
                                                            path: '/',
                                                            component: () => import('@/components/Projects/ProjectsDigests'),
                                                        },
                                                        {
                                                            path: ':ID_DIGESTS',
                                                            component: () => import('@/components/BreadCrumbs/BreadCrumbDigest'),
                                                            redirect: {name: 'ForumEventDigestsItem'},
                                                            children: [
                                                                {
                                                                    name: 'ForumEventDigestsItem',
                                                                    path: '/',
                                                                    component: () => import('@/components/Projects/ProjectsDigestsItem'),
                                                                },
                                                            ]
                                                        },
                                                    ],
                                                },
                                                {
                                                    path: 'pdf',
                                                    component: () => import('@/components/BreadCrumbs/BreadCrumbItem'),
                                                    redirect: {name: 'ForumEventPdf'},
                                                    props: {title: 'Итоги дня'},
                                                    children: [
                                                        {
                                                            name: 'ForumEventPdf',
                                                            path: '/',
                                                            component: () => import('@/components/Projects/ProjectsPdf'),
                                                        },
                                                    ],
                                                },
                                                {
                                                    path: 'settings',
                                                    component: () => import('@/components/BreadCrumbs/BreadCrumbItem'),
                                                    redirect: {name: 'ForumEventSettings'},
                                                    props: {title: 'Настройки'},
                                                    children: [
                                                        {
                                                            name: 'ForumEventSettings',
                                                            path: '/',
                                                            component: () => import('@/components/Projects/ProjectsSettings'),
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ]
                                },
                            ],
                        },
                    ],
                },
                {
                    path: 'pages/users',
                    component: () => import('@/components/BreadCrumbs/BreadCrumbItem'),
                    redirect: {name: 'Users'},
                    props: {title: 'Пользователи'},
                    meta: {
                        permissionsByModule: 'users',
                    },
                    children: [
                        {
                            name: 'Users',
                            path: '/',
                            component: () => import('@/views/pages/Users'),
                        },
                    ],
                },
                // @TODO: удалить демо-компоненты
                /*
                {
                    name: 'ComponentsDemo',
                    path: 'dashboard/components-demo',
                    component: () => import('@/views/dashboard/ComponentsDemo'),
                },
                 */
                {
                    path: '403',
                    name: 'Error403',
                    component: () => import('@/views/errors/Error403')
                },
            ]
        },

    ],
})